import {diffChars, diffWords} from "diff";

export class KraModel {
    constructor(kra) {
        this.id = kra.id;
        this.userId = kra.user_id;
        this.name = kra.name;
        this.department = kra.department_parent ?? '';
        this.human = kra.user?.name ?? '';
        this.leader = kra.leader?.name ?? '';
        this.status = this.getLabelStatus(kra.status);
        this.bgStatus = this.getBgStatus(kra.status);
    }
    getLabelStatus(value) {
        switch (value) {
            case 0:
                return 'Chờ duyệt'
            case 1:
                return 'Đã duyệt'
            default:
                return ''
        }
    }
    getBgStatus(value) {
        switch (value) {
            case 0:
                return 'bg-yellow'
            case 1:
                return 'bg-green'
            default:
                return ''
        }
    }
}

export class KraByUserModel {
    constructor(kra) {
        this.id = kra.id;
        this.userId = kra.user_id;
        this.name = this.getNameKra(kra);
        this.oldContent = kra.old_content
        this.newContent = kra.new_content
        this.oldName = this.renderDiff("name", "old", kra.old_content, kra.new_content);
        this.newName = this.renderDiff("name", "new", kra.old_content, kra.new_content);
        this.oldResult = this.renderDiff("request_result", "old", kra.old_content, kra.new_content);
        this.newResult = this.renderDiff("request_result", "new", kra.old_content, kra.new_content);
        this.oldHour = this.renderDiff("number_hour", "old", kra.old_content, kra.new_content);
        this.newHour = this.renderDiff("number_hour", "new", kra.old_content, kra.new_content);
        this.oldPercent = this.renderDiff("percent_score", "old", kra.old_content, kra.new_content);
        this.newPercent = this.renderDiff("percent_score", "new", kra.old_content, kra.new_content);
        this.status = kra.status;
        this.selected = false;
        this.disabled = kra.status !== 0;
    }

    escapeHtml(str = "") {
        return String(str)
            .replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]))
            .replace(/'/g, "&#39;");
    }
    getNameKra(kra) {
        switch (kra.type) {
            case 0:
                return kra?.old_content?.name;
            case 1:
                return kra?.new_content?.name;
            default:
                return ''
        }
    }
    renderDiff(field, mode, oldContent, newContent) {
        const oldText = oldContent?.[field] ?? "";
        const newText = newContent?.[field] ?? "";

        if (!oldContent && newContent) {
            return mode === "new" ? `<span style="color: green">${this.escapeHtml(newText)}</span>` : "";
        }
        if (!newContent && oldContent) {
            return mode === "old" ? `<span style="color: red">${this.escapeHtml(oldText)}</span>` : "";
        }

        const a = oldText.normalize();
        const b = newText.normalize();

        let diffs = diffWords(a, b);
        if (!diffs.some(p => p.added || p.removed)) {
            diffs = diffChars(a, b);
        }

        return diffs
            .map(part => {
                if (part.removed && mode === "old") {
                    return `<span style="color: red">${this.escapeHtml(part.value)}</span>`;
                }
                if (part.added && mode === "new") {
                    return `<span style="color: green">${this.escapeHtml(part.value)}</span>`;
                }
                if (!part.added && !part.removed) {
                    return this.escapeHtml(part.value);
                }
                return "";
            })
            .join("");
    }
}